import { render, staticRenderFns } from "./BatteryBackup.vue?vue&type=template&id=b59200a0&scoped=true&"
import script from "./BatteryBackup.vue?vue&type=script&lang=ts&"
export * from "./BatteryBackup.vue?vue&type=script&lang=ts&"
import style0 from "./BatteryBackup.vue?vue&type=style&index=0&id=b59200a0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59200a0",
  null
  
)

export default component.exports